export enum UserProfileNode {
  PracticeInfo = 1,
  CreditCard = 2,
}
